import { AdvancingActivityLog } from "advancing/activity/AdvancingActivityLog";
import { getProvideActivitySource } from "advancingprovide/utils";
import React from "react";
import { useParams } from "react-router";

export const ActivityTab = () => {
  const { secret } = useParams();

  return <AdvancingActivityLog source={getProvideActivitySource(secret)} />;
};
